// §4.4 partial — admin/pwa flag toggle UI (Task 1 kill-switch).
// Composer auto-collects this into routes.generated.ts.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const AdminPwaPage = lazyWithRetry(() => import("./pages/AdminPwaPage"));

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [{ path: "/admin/pwa", Component: AdminPwaPage }],
  },
];

export default routes;
